import axios from '@/api/axiosInstance';
import * as Sentry from '@sentry/nextjs';

export default async function createProgress({ taskActivityId, progressData }) {
  let response = null;
  try {
    response = await axios({
      url: `${process.env.NEXT_PUBLIC_API_V2}/progress`,
      method: 'post',
      data: { taskActivityId, progressData },
    });
  } catch (error) {
    response = await axios({
      url: `${process.env.NEXT_PUBLIC_API}/progress`,
      method: 'post',
      data: { taskActivityId, progressData },
    });
    Sentry.captureException(error, {
      extra: {
        moreInfo: 'API V2 failed, API V1 worked',
      },
    });
  }
  return response.data;
}
